import ChargingPointOperations from "@/plugins/chargingPointsOperations/chargingPointsOperations";

export default {
  install(Vue) {
    Vue.prototype.$chargingPointOperations = new ChargingPointOperations();
  }
}
